/* ============================================================
   Notre Chanson — landing.js
   Small landing-only flourishes: fake play toggles on the hero
   "video" and the sample player (no real media shipped — the
   affordance mirrors the reference without a heavy asset), and
   an accordion that keeps a single FAQ item open at a time.
   ============================================================ */
(function () {
  'use strict';

  // Hero: the video autoplays muted+looped as the visual; the button plays
  // a song sample (mp3). The button label/icon is driven straight off the
  // audio element's real play/pause/ended events, so it can never drift out
  // of sync (the "plays but won't pause" class of bug). Init-guarded so the
  // handler is bound exactly once even if the script is evaluated twice.
  var sampleBtn = document.getElementById('hero-sample-btn');
  var sampleAudio = document.getElementById('hero-sample');
  if (sampleBtn && sampleAudio && !sampleBtn.dataset.nmSampleInit) {
    sampleBtn.dataset.nmSampleInit = '1';
    var sampleLabel = sampleBtn.querySelector('.nm-video__unmute-label');
    function setSample(on) {
      sampleBtn.classList.toggle('is-playing', on);
      sampleBtn.setAttribute('aria-pressed', String(on));
      if (sampleLabel) sampleLabel.textContent = on ? 'Pause' : 'Écouter un exemple de chanson';
    }
    sampleAudio.addEventListener('play',  function () { setSample(true); });
    sampleAudio.addEventListener('pause', function () { setSample(false); });
    sampleAudio.addEventListener('ended', function () { setSample(false); });
    sampleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (sampleAudio.paused) {
        var p = sampleAudio.play();
        if (p && p.catch) { p.catch(function () {}); }
      } else {
        sampleAudio.pause();
      }
    });
  }

  // "Ce que vous recevez" — real audio player: vinyl + waveform.
  var rAudio = document.getElementById('receive-audio');
  var rPlay = document.getElementById('receive-play');
  var rWave = document.getElementById('receive-wave');
  if (rAudio && rPlay && rWave) {
    var player = rPlay.closest('.nm-aplayer');
    var vinyl = document.getElementById('receive-vinyl');
    var elCur = document.getElementById('receive-cur');
    var elTot = document.getElementById('receive-tot');
    var elDur = document.getElementById('receive-dur');

    // Static waveform pattern (organic-looking). 0..1 → bar height.
    var PATTERN = [.35,.5,.42,.66,.8,.55,.7,.9,.6,.75,.5,.62,.85,.7,.55,.68,.92,.6,.48,.72,.83,.58,.66,.88,.7,.52,.63,.8,.95,.62,.5,.72,.84,.58,.68,.9,.64,.46,.6,.78,.7,.55,.66,.82,.6,.5,.44,.36];
    var bars = PATTERN.map(function (h) {
      var b = document.createElement('span');
      b.className = 'nm-aplayer__bar';
      b.style.height = (26 + h * 74) + '%';
      rWave.appendChild(b);
      return b;
    });

    function fmt(t) {
      if (!isFinite(t) || t < 0) return '—';
      t = Math.floor(t); var m = Math.floor(t / 60), s = t % 60;
      return m + ':' + (s < 10 ? '0' : '') + s;
    }
    function setDuration() {
      var d = rAudio.duration;
      if (isFinite(d)) { if (elTot) elTot.textContent = fmt(d); if (elDur) elDur.textContent = fmt(d); }
    }
    function paint() {
      var d = rAudio.duration, p = (isFinite(d) && d > 0) ? rAudio.currentTime / d : 0;
      var n = Math.round(p * bars.length);
      for (var i = 0; i < bars.length; i++) bars[i].classList.toggle('is-played', i < n);
      if (elCur) elCur.textContent = fmt(rAudio.currentTime);
      rWave.setAttribute('aria-valuenow', Math.round(p * 100));
    }

    rAudio.addEventListener('loadedmetadata', setDuration);
    rAudio.addEventListener('durationchange', setDuration);
    rAudio.addEventListener('timeupdate', paint);
    rAudio.addEventListener('play',  function () { player.classList.add('is-playing'); if (vinyl) vinyl.classList.add('is-spinning'); });
    rAudio.addEventListener('pause', function () { player.classList.remove('is-playing'); if (vinyl) vinyl.classList.remove('is-spinning'); });
    rAudio.addEventListener('ended', function () { rAudio.currentTime = 0; paint(); });

    rPlay.addEventListener('click', function () {
      if (rAudio.paused) { var p = rAudio.play(); if (p && p.catch) p.catch(function () {}); }
      else { rAudio.pause(); }
    });
    function seek(clientX) {
      var rect = rWave.getBoundingClientRect();
      var ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      if (isFinite(rAudio.duration)) { rAudio.currentTime = ratio * rAudio.duration; paint(); }
    }
    rWave.addEventListener('click', function (e) { seek(e.clientX); });
    rWave.addEventListener('keydown', function (e) {
      if (!isFinite(rAudio.duration)) return;
      if (e.key === 'ArrowRight') { rAudio.currentTime = Math.min(rAudio.duration, rAudio.currentTime + 5); paint(); }
      else if (e.key === 'ArrowLeft') { rAudio.currentTime = Math.max(0, rAudio.currentTime - 5); paint(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); rPlay.click(); }
    });
    setDuration();
  }

  // Hero delivery badge — computed from today so it never shows a past date.
  if (window.NM && NM.deliveryLabel) {
    document.querySelectorAll('[data-delivery]').forEach(function (el) {
      el.textContent = 'Livré avant le ' + NM.deliveryLabel();
    });
  }


  // Bulles du hero : garder le texte sur UNE seule ligne, à la plus grande
  // taille possible, sans jamais déborder. Le CSS (vw) sert de repli si le
  // JS ne tourne pas ; ici on affine avec une mesure réelle, refaite au
  // resize et une fois les polices chargées (leurs métriques changent).
  (function () {
    var items = [
      { box: document.querySelector('.nm-pill'),      text: document.querySelector('.nm-pill__text'),      badge: '.nm-pill__badge',      max: 15.5 },
      { box: document.querySelector('.nm-medal-bar'), text: document.querySelector('.nm-medal-bar__text'), badge: '.nm-medal-bar__rank', max: 17 }
    ].filter(function (it) { return it.box && it.text; });
    if (!items.length) return;

    // Ce que le contenu dépasse, à droite, du bord INTÉRIEUR de la bulle.
    // scrollWidth est inutilisable ici : en cas de débordement il omet le
    // padding de fin, la mesure s'arrêterait ~10px trop tôt.
    function overflowRight(it) {
      var cs = getComputedStyle(it.box), rb = it.box.getBoundingClientRect();
      var inner = rb.right - parseFloat(cs.borderRightWidth) - parseFloat(cs.paddingRight);
      var edge = it.text.getBoundingClientRect().right;
      var badge = it.box.querySelector(it.badge);
      if (badge) edge = Math.max(edge, badge.getBoundingClientRect().right);
      return edge - inner;
    }

    // On repart toujours de la taille CSS, calibrée pour tenir même sans JS,
    // et on ne grandit qu'en vérifiant à chaque pas. Conséquence : un rendu
    // trop grand est impossible, même si la mesure tombe au mauvais moment.
    // On n'agrandit qu'une fois la police définitive posée : mesurer sur la
    // police de repli, plus étroite, donnerait une taille qui déborde ensuite.
    var fontsReady = !(document.fonts && document.fonts.status !== 'loaded');
    function fit(it) {
      it.text.style.fontSize = '';
      var f = parseFloat(getComputedStyle(it.text).fontSize), guard = 0;
      if (!(f > 0)) return;
      while (overflowRight(it) > 0.5 && f > 6.5 && guard++ < 150) {
        f -= 0.25; it.text.style.fontSize = f + 'px';
      }
      while (fontsReady && f < it.max && guard++ < 300) {
        it.text.style.fontSize = (f + 0.25) + 'px';
        // Seuil serré ici : un simple test suivi d'un break, aucun risque de
        // boucle, donc on refuse le moindre dépassement.
        if (overflowRight(it) > 0.05) { it.text.style.fontSize = f + 'px'; break; }
        f += 0.25;
      }
    }
    function fitAll() {
      if (document.fonts && document.fonts.status === 'loaded') fontsReady = true;
      items.forEach(fit);
    }

    fitAll();
    // Safari n'applique Playfair qu'après coup : sans ces rappels la mesure
    // se fait sur la police de repli, plus étroite, et le texte déborde une
    // fois la vraie police posée. Chrome iOS et le navigateur in-app de
    // Facebook ne montraient pas le bug car la police y était déjà en cache.
    [250, 800, 2000].forEach(function (d) { setTimeout(fitAll, d); });
    window.addEventListener('load', fitAll);
    if (document.fonts) {
      if (document.fonts.ready) document.fonts.ready.then(function () { fontsReady = true; fitAll(); }).catch(function () {});
      if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', fitAll);
    }
    var t;
    function later(ms) { clearTimeout(t); t = setTimeout(fitAll, ms); }
    window.addEventListener('resize', function () { later(120); });
    // On observe le CONTENEUR, jamais le texte : sa largeur ne dépend pas de
    // nos changements de police, donc aucune boucle de rétroaction.
    if (window.ResizeObserver && items[0].box.parentElement) {
      new ResizeObserver(function () { later(60); }).observe(items[0].box.parentElement);
    }
  })();

  // FAQ accordion — single open item.
  var items = document.querySelectorAll('.nm-faq__item');
  items.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      items.forEach(function (o) { if (o !== item) o.open = false; });
    });
  });
})();
